import React, { Component } from 'react';
import { Segment } from 'semantic-ui-react';

export default class Drawing extends Component {
  render() {
    return (
      <Segment className="br0 h100 m0">
        <Segment>salam</Segment>
        <Segment color="red" inverted>
          aleyk
        </Segment>
      </Segment>
    );
  }
}
